import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import API_URL from "../api/API";
import SignatureModal from "../components/signature/SignatureModal";
import PDFViewer from "../components/pdf/PDFViewer";
import { useCustomerAuthContext } from '../customer/commoncomponents/useCustomerAuthContext';


export default function TestPDF() {

    const [signature, setSignature] = useState("");
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { customer } = useCustomerAuthContext();
    const [error, setError] = useState("");

    /*const pdfData = {

        business: {
            name: "ABC Spa",
            location: "Downtown",
        },

        signer: {
            firstName: "John",
            lastName: "Smith",
            email: "john@email.com",
            phone: "1234567890",
        },

        waiver: {
            title: "Waxing Waiver",
            version: 1,
            sections: [
                {
                    title: "Medical Conditions",
                    content: "<p>I confirm I have disclosed all medical conditions.</p>",
                },
                {
                    title: "Liability",
                    content: "<p>I understand the risks and release the business from liability.</p>",
                },
            ],
        },

        eligibilityAnswers: [
            {
                question: "Are you pregnant?",
                answer: "No",
            },
            {
                question: "Any allergies?",
                answer: "Latex",
            },
        ],

        signature, // Uses the current React state

        signedAt: new Date(),

    };*/

    //temp data
    const waiverId = "6a4ce55be7d370c012442aba";
    const signerId = customer._id; //the backend already knows who the customer is, so do not send it use it only to cross check if same user
    const eligibilityAnswers = [
        {
            question: "Pregnant?",
            answer: "No"
        }
    ];

    const completeSigning = async () => {
        
        try {
            const res = await fetch(
                API_URL.CUSTOMER_GENERATE_SIGNED_PDF_FILE,
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${customer.token}`,
                    },

                    body: JSON.stringify({

                        waiverId,

                        signerId,

                        signature,

                        eligibilityAnswers,

                    }),
                }
            );

            const data = await res.json();
            setLoading(false);

            if (data.success) {           
                alert(data.message);
                //navigate(`/business/pdf/${data.pdfId}`);
                window.open(data.viewUrl, "_blank");
            } else {
                setError(data.message || 'Update failed.');
            }
        } catch (err) {
            console.error('Error saving signature', err);
            setLoading(false);
            setError('Server error during PDF Generation.');
        }        

    };

    return (
        <div className="space-y-5">

            <button
                onClick={() => setOpen(true)}
                className="bg-blue-600 text-white px-5 py-2 rounded"
            >
                Sign Waiver
            </button>

            <SignatureModal
                open={open}
                onClose={() => setOpen(false)}
                onSave={setSignature}
            />

            {signature && (
                <>
                    <img
                        src={signature}
                        alt="Signature"
                        className="border rounded"
                    />

                    <button
                        onClick={completeSigning}
                        disabled={loading}
                        className="bg-green-600 text-white px-5 py-2 rounded mt-4"
                    >
                        {loading ? "Generating PDF..." : "Complete Signing"}
                    </button>

                    {error && (
                        <p className="text-red-500 mt-2">
                            {error}
                        </p>
                    )}
                </>
            )}

        </div>
    );
}